/*
  Shop the look on mood pages (sections/mm-shop-the-look.liquid): when a mood has several looks they take turns.
  Every few seconds the next look fades in; arrows and dots step through them; a sideways swipe on the heading
  area does the same (the row of pieces keeps its own sideways scroll). It starts on a different look each visit.
  The turns stop for good once the shopper touches a look (a size, an add button), so nothing moves under them.
  Paused while hovered, keyboard focused, off screen or in a hidden tab. Reduced motion: no automatic change.
*/
(function () {
  var SWIPE_MIN = 40;

  function start(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-mm-looks-slide]')).filter(function (s) {
      if (s.querySelector('[data-mm-look]')) return true;
      s.remove();
      return false;
    });
    var nav = root.querySelector('[data-mm-looks-nav]');
    if (slides.length < 2) { if (slides[0]) slides[0].classList.add('is-active'); return; }

    var dotsBox = root.querySelector('[data-mm-looks-dots]');
    var dots = slides.map(function (s, k) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'mm-looks__dot';
      d.setAttribute('aria-label', 'Show look ' + (k + 1) + ': ' + (s.dataset.lookName || ''));
      d.addEventListener('click', function () { go(k); });
      dotsBox.appendChild(d);
      return d;
    });
    if (nav) nav.hidden = false;

    var i = 0;
    var ms = Math.max(5, parseInt(root.dataset.seconds, 10) || 7) * 1000;
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hovered = false, focused = false, visible = true, engaged = false, timer = null;

    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        var on = k === i;
        s.classList.toggle('is-active', on);
        if (on) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
      });
      dots.forEach(function (d, k) {
        d.classList.toggle('is-active', k === i);
        if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
    }
    function tick() { if (!hovered && !focused && visible && !engaged && !document.hidden) show(i + 1); }
    function run() { clearInterval(timer); if (!still && !engaged) timer = setInterval(tick, ms); }
    function go(n) { show(n); run(); }

    root.querySelectorAll('[data-mm-looks-step]').forEach(function (b) {
      b.addEventListener('click', function () { go(i + (parseInt(b.dataset.mmLooksStep, 10) || 1)); });
    });
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      if (!e.target.closest('.mm-looks__nav')) return;
      e.preventDefault();
      go(i + (e.key === 'ArrowRight' ? 1 : -1));
    });

    /* Touching a look's own controls ends the turns for this visit */
    function engage(e) {
      if (e.target.closest('.mm-looks__nav')) return;
      if (!e.target.closest('select, button, [data-mm-pair-add], [data-mm-set-add]')) return;
      engaged = true; clearInterval(timer);
    }
    root.addEventListener('click', engage, true);
    root.addEventListener('change', engage, true);

    root.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hovered = true; });
    root.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') hovered = false; });
    root.addEventListener('focusin', function (e) {
      var kb = true;
      try { kb = e.target.matches(':focus-visible'); } catch (err) {}
      focused = kb;
    });
    root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) focused = false; });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { visible = entries[entries.length - 1].isIntersecting; }).observe(root);
    }

    /* Swipe, but not on the row of pieces, which scrolls sideways by itself on phones */
    var sx = 0, sy = 0, pid = null;
    root.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' || !e.isPrimary) return;
      if (e.target.closest('.mm-look__row, .mm-looks__nav, select, button, a')) return;
      pid = e.pointerId; sx = e.clientX; sy = e.clientY;
    });
    root.addEventListener('pointerup', function (e) {
      if (e.pointerId !== pid) return;
      pid = null;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      if (Math.abs(dx) < SWIPE_MIN || Math.abs(dx) < Math.abs(dy) * 1.2) return;
      go(i + (dx < 0 ? 1 : -1));
    });
    root.addEventListener('pointercancel', function () { pid = null; });

    /* A different first look each visit */
    show(Math.floor(Math.random() * slides.length));
    run();
  }
  function all() { document.querySelectorAll('[data-mm-looks]').forEach(start); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
